// import {
//   Alert,
//   Image,
//   ImageBackground,
//   Platform,
//   Share,
//   StyleSheet,
//   Text,
//   TouchableOpacity,
//   View,
// } from "react-native";
// import React, { useEffect, useState } from "react";
// import { AppIcons } from "../../../assets/images";
// import { AppTheme } from "../../../utils/theme";
// import { useNavigation, useRoute } from "@react-navigation/native";
// import { NativeStackNavigationProp } from "@react-navigation/native-stack";
// import LinearGradient from "react-native-linear-gradient";
// import Spacer from "../../../components/global/Spacer";
// import SoundPlayer from "react-native-sound-player";
// import { userAction } from "../../../redux/reducers/user";
// import { ROUTE_NAME } from "../../../utils/routes";
// import socketService from "../../../services/socketService";
// import { useAppSelector } from "../../../redux/storeHook";
// import { DEEP_LINK } from "../../../utils/contants";

// export interface Player {
//   id: string;
//   name: string;
//   color: string;
//   isReady: boolean;
//   isHost: boolean;
// }

// export interface Room {
//   id: string;
//   hostId: string;
//   maxPlayers: number;
//   players: Player[];
//   gameState: any | null;
//   gameStarted: boolean;
//   messages: any[];
// }

// export interface RootObject {
//   roomId: string;
//   playerName: string;
//   color: string;
//   isHost: boolean;
//   room: Room;
// }
// const WaitingRoom = () => {
//   const route = useRoute();
//   const { userData } = useAppSelector((s) => s.user);
//   const navigation = useNavigation<NativeStackNavigationProp<any>>();
//   const {
//     roomId,
//     playerName,
//     color,
//     isHost,
//     room: initialRoom,
//   } = route.params as RootObject;
//   const [room, setRoom] = useState<Room>(initialRoom);
//   const [myReadyState, setMyReadyState] = useState(isHost);

//   console.log("@ params : ", route.params);

//   const onPress = () => {
//     handleStartGame();
//   };

//   useEffect(() => {
//     setupSocketListeners();
//     // return () => {
//     //   socketService.removeListener("playerJoined");
//     //   socketService.removeListener("playerLeft");
//     //   socketService.removeListener("roomUpdated");
//     //   socketService.removeListener("gameStarted");
//     // };
//   }, []);

//   useEffect(() => {
//     setTimeout(() => {
//       handleToggleReady();
//     }, 2000);
//   }, []);
//   const setupSocketListeners = () => {
//     // @ts-ignore
//     socketService.onPlayerJoined(({ player, room: updatedRoom }) => {
//       setRoom(updatedRoom);
//     });
//     // @ts-ignore
//     socketService.onPlayerLeft(({ room: updatedRoom }) => {
//       setRoom(updatedRoom);
//     });
//     // @ts-ignore
//     socketService.onRoomUpdated(({ room: updatedRoom }) => {
//       setRoom(updatedRoom);
//     });
//     // @ts-ignore
//     socketService.onGameStarted(({ players, numPlayers }) => {
//       // Navigate to game screen with online mode
//       socketService.removeListener("playerJoined");
//       socketService.removeListener("playerLeft");
//       socketService.removeListener("roomUpdated");
//       socketService.removeListener("gameStarted");
//       navigation.replace(ROUTE_NAME.PlayOnline, {
//         roomId,
//         playerName,
//         myColor: color,
//         players,
//         numPlayers,
//       });
//     });
//   };
//   const handleToggleReady = async () => {
//     if (isHost) return; // Host is always ready
//     try {
//       const response: any = await socketService.toggleReady(roomId);
//       if (response.success) {
//         setMyReadyState(response.isReady);
//       }
//     } catch (error) {
//       Alert.alert("Error", "Failed to update ready state");
//     }
//   };
//   const handleStartGame = async () => {
//     try {
//       await socketService.startGame(roomId);
//     } catch (error) {
//       // @ts-ignore
//       Alert.alert("Error", error || "Failed to start game");
//     }
//   };
//   const handleLeaveRoom = () => {
//     Alert.alert("Leave Room", "Are you sure you want to leave?", [
//       { text: "Cancel", style: "cancel" },
//       {
//         text: "Leave",
//         style: "destructive",
//         onPress: () => {
//           socketService.leaveRoom(roomId);
//           socketService.removeListener("playerJoined");
//           socketService.removeListener("playerLeft");
//           socketService.removeListener("roomUpdated");
//           socketService.removeListener("gameStarted");
//           navigation.goBack();
//         },
//       },
//     ]);
//   };

//   const shareRoomCode = async (roomCode: any) => {
//     try {
//       const appStoreLink =
//         Platform.OS === "ios"
//           ? "https://apps.apple.com/in/app/ludo-voice/id1511172928"
//           : "https://play.google.com/store/apps/details?id=com.netscapelabs.ludovoice";

//       //       const message = `🎲 Join my *Ludo Voice* room!

//       // 🧩 Room Code: ${roomCode}

//       // 📲 Download the app:
//       // ${appStoreLink}

//       // Open the app, enter the room code, and play with me! 🚀`;

//       const deeplink = `${DEEP_LINK}joinroom=${roomCode}`;
//       const message = `🎲 Join my *Ludo Voice* room!

// 🧩 Room Code: ${roomCode}

// 📲 join the room by clicking on this link:
// ${deeplink}

// 📲 Download the app:

// ${appStoreLink}

// Open the app, enter the room code, and play with me! 🚀`;
//       await Share.share({
//         message: message,
//       });
//     } catch (error: any) {
//       console.log(error.message);
//     }
//   };
//   const allReady = room?.players.every((p) => p.isReady);
//   const canStart = isHost && allReady && room?.players.length >= 2;
//   return (
//     <ImageBackground source={AppIcons.screenBackground} style={styles.mainView}>
//       <TouchableOpacity
//         onPress={() => {
//           handleLeaveRoom();
//           userAction.setTouchSound(true);
//         }}
//         style={styles.backIcon}
//       >
//         <Image
//           source={AppIcons.BackIcon}
//           style={{
//             width: 50,
//             height: 40,
//           }}
//           resizeMode="contain"
//         />
//       </TouchableOpacity>
//       <View style={styles.container}>
//         <Text style={styles.title}>Play Online</Text>
//         <Text style={styles.t1}>Room Code</Text>
//         <View style={styles.roomView}>
//           <LinearGradient
//             colors={[
//               AppTheme.colors.linearGradient_1,
//               AppTheme.colors.linearGradient_2,
//             ]}
//             start={{ x: 0, y: 0 }}
//             end={{ x: 1, y: 1 }}
//             style={styles.codeView}
//           >
//             <Text style={styles.title}>{roomId}</Text>
//           </LinearGradient>
//           <TouchableOpacity
//             onPress={() => shareRoomCode(roomId)}
//             style={{ marginLeft: 10 }}
//           >
//             <Image source={AppIcons.Share} style={styles.share} />
//           </TouchableOpacity>
//         </View>
//         <Text style={styles.t2}>
//           Share this with your friends and ask them to join
//         </Text>
//         <Spacer size={30} />
//         {/* 2 players ui */}
//         {room?.maxPlayers == 2 && (
//           <View style={styles.userView}>
//             <View style={styles.userCard}>
//               <Image source={AppIcons.OnlineUser} style={styles.icon} />
//               <View style={styles.rowView}>
//                 <Text style={styles.name}>
//                   {room?.players[0]?.name == userData?.name
//                     ? "You"
//                     : room?.players[0]?.name}
//                 </Text>
//                 <LinearGradient
//                   colors={[
//                     AppTheme.colors.linearGradient_1,
//                     AppTheme.colors.linearGradient_2,
//                   ]}
//                   start={{ x: 0, y: 0 }}
//                   end={{ x: 1, y: 1 }}
//                   style={styles.hostView}
//                 >
//                   <Text style={styles.hostText}>HOST</Text>
//                 </LinearGradient>
//               </View>
//             </View>
//             <Image
//               style={[
//                 styles.vsImg,
//                 {
//                   left: "45%",
//                 },
//               ]}
//               source={AppIcons.vsIcon}
//             />
//             <View style={styles.userCard}>
//               <Image source={AppIcons.OnlineUser} style={styles.icon} />
//               <Text style={styles.name}>
//                 {room?.players?.length == 2
//                   ? room?.players[1]?.name == userData?.name
//                     ? "You"
//                     : room?.players[1]?.name
//                   : "Waiting..."}
//               </Text>
//             </View>
//           </View>
//         )}
//         {/* 3 player */}
//         {room?.maxPlayers == 3 && (
//           <View style={styles.userView}>
//             <View style={styles.userCard}>
//               <Image source={AppIcons.OnlineUser} style={styles.icon} />
//               <View style={styles.rowView}>
//                 <Text style={styles.name}>
//                   {room?.players[0]?.name == userData?.name
//                     ? "You"
//                     : room?.players[0]?.name}
//                 </Text>
//                 <LinearGradient
//                   colors={[
//                     AppTheme.colors.linearGradient_1,
//                     AppTheme.colors.linearGradient_2,
//                   ]}
//                   start={{ x: 0, y: 0 }}
//                   end={{ x: 1, y: 1 }}
//                   style={styles.hostView}
//                 >
//                   <Text style={styles.hostText}>HOST</Text>
//                 </LinearGradient>
//               </View>
//             </View>
//             <Image
//               style={[
//                 styles.vsImg,
//                 {
//                   left: "45%",
//                 },
//               ]}
//               source={AppIcons.vsIcon}
//             />
//             <View style={styles.userCard}>
//               <Image source={AppIcons.OnlineUser} style={styles.icon} />
//               <Text style={styles.name}>
//                 {room?.players?.length == 3
//                   ? room?.players[1]?.name == userData?.name
//                     ? "You"
//                     : room?.players[1]?.name
//                   : "Waiting..."}
//               </Text>
//             </View>
//             <View style={styles.userCard}>
//               <Image source={AppIcons.OnlineUser} style={styles.icon} />
//               <Text style={styles.name}>
//                 {room?.players?.length == 3
//                   ? room?.players[2]?.name == userData?.name
//                     ? "You"
//                     : room?.players[2]?.name
//                   : "Waiting..."}
//               </Text>
//             </View>
//           </View>
//         )}
//         {/* 4 players */}
//         {room?.maxPlayers == 4 && (
//           <View style={styles.userView}>
//             <View style={styles.userCard}>
//               <Image source={AppIcons.OnlineUser} style={styles.icon} />
//               <View style={styles.rowView}>
//                 <Text style={styles.name}>
//                   {room?.players[0]?.name == userData?.name
//                     ? "You"
//                     : room?.players[0]?.name}
//                 </Text>
//                 <LinearGradient
//                   colors={[
//                     AppTheme.colors.linearGradient_1,
//                     AppTheme.colors.linearGradient_2,
//                   ]}
//                   start={{ x: 0, y: 0 }}
//                   end={{ x: 1, y: 1 }}
//                   style={styles.hostView}
//                 >
//                   <Text style={styles.hostText}>HOST</Text>
//                 </LinearGradient>
//               </View>
//             </View>
//             <Image
//               style={[
//                 styles.vsImg,
//                 {
//                   left: "45%",
//                 },
//               ]}
//               source={AppIcons.vsIcon}
//             />
//             <View style={styles.userCard}>
//               <Image source={AppIcons.OnlineUser} style={styles.icon} />
//               <Text style={styles.name}>
//                 {room?.players?.length == 4
//                   ? room?.players[1]?.name == userData?.name
//                     ? "You"
//                     : room?.players[1]?.name
//                   : "Waiting..."}
//               </Text>
//             </View>
//             <View style={styles.userCard}>
//               <Image source={AppIcons.OnlineUser} style={styles.icon} />
//               <Text style={styles.name}>
//                 {room?.players?.length == 4
//                   ? room?.players[2]?.name == userData?.name
//                     ? "You"
//                     : room?.players[2]?.name
//                   : "Waiting..."}
//               </Text>
//             </View>
//             <View style={styles.userCard}>
//               <Image source={AppIcons.OnlineUser} style={styles.icon} />
//               <Text style={styles.name}>
//                 {room?.players?.length == 4
//                   ? room?.players[3]?.name == userData?.name
//                     ? "You"
//                     : room?.players[3]?.name
//                   : "Waiting..."}
//               </Text>
//             </View>
//           </View>
//         )}
//         <Spacer size={20} />
//         {canStart ? (
//           <TouchableOpacity
//             activeOpacity={1}
//             style={{ alignSelf: "center", marginTop: 20 }}
//             onPress={() => {
//               onPress();
//               // SoundPlayer.stop();
//               userAction.setMusicPreference(false);
//               userAction.setTouchSound(true);
//               userAction.setPlayGame(true);
//             }}
//           >
//             <LinearGradient
//               colors={[
//                 AppTheme.colors.linearGradient_5,
//                 AppTheme.colors.linearGradient_6,
//               ]}
//               start={{ x: 0, y: 0 }}
//               end={{ x: 1, y: 1 }}
//               style={styles.googleBtn1}
//             >
//               <LinearGradient
//                 colors={[
//                   AppTheme.colors.linearGradient_1,
//                   AppTheme.colors.linearGradient_2,
//                 ]}
//                 start={{ x: 0, y: 0 }}
//                 end={{ x: 1, y: 1 }}
//                 style={styles.googleBtn}
//               >
//                 <Text style={styles.startText}>START GAME</Text>
//               </LinearGradient>
//             </LinearGradient>
//           </TouchableOpacity>
//         ) : (
//           <Text style={styles.bottomText}>
//             {isHost
//               ? "Waiting for players to join ...."
//               : "Waiting for host to start the game ...."}
//           </Text>
//         )}
//       </View>
//     </ImageBackground>
//   );
// };

// export default WaitingRoom;

// const styles = StyleSheet.create({
//   mainView: {
//     flex: 1,
//   },
//   backIcon: {
//     position: "absolute",
//     top: 70,
//     right: 0,
//   },
//   container: {
//     flex: 1,
//     justifyContent: "center",
//   },
//   title: {
//     alignSelf: "center",
//     fontSize: 36,
//     fontFamily: AppTheme.fonts.BUBBLE_BOBBLE,
//     color: AppTheme.colors.white,
//     textShadowColor: AppTheme.colors.outline,
//     textShadowOffset: { width: 2, height: 2 },
//     textShadowRadius: 2,
//   },
//   share: {
//     height: 40,
//     width: 40,
//   },
//   t1: {
//     alignSelf: "center",
//     marginVertical: 10,
//     fontSize: 18,
//     color: `${AppTheme.colors.white}80`,
//     fontFamily: AppTheme.fonts.ALEXANDRIA_BOLD,
//   },
//   roomView: {
//     flexDirection: "row",
//     alignItems: "center",
//     justifyContent: "center",
//   },
//   codeView: {
//     alignSelf: "center",
//     width: 180,
//     height: 60,
//     alignItems: "center",
//     justifyContent: "center",
//     borderRadius: 14,
//   },
//   t2: {
//     width: 280,
//     alignSelf: "center",
//     marginVertical: 10,
//     fontSize: 16,
//     color: `${AppTheme.colors.white}80`,
//     fontFamily: AppTheme.fonts.ALEXANDRIA_MEDIUM,
//     textAlign: "center",
//   },
//   userView: {
//     width: "100%",
//     paddingHorizontal: 24,
//     flexDirection: "row",
//     alignItems: "center",
//     justifyContent: "space-between",
//     flexWrap: "wrap",
//     position: "relative",
//   },
//   userCard: {
//     alignItems: "center",
//     marginTop: 10,
//   },
//   icon: {
//     width: 130,
//     height: 130,
//     marginBottom: 7,
//   },
//   vsImg: {
//     position: "absolute",
//     zIndex: 999,
//     height: 80,
//     width: 80,
//   },
//   rowView: {
//     flexDirection: "row",
//     alignItems: "center",
//   },
//   name: {
//     fontSize: 16,
//     fontFamily: AppTheme.fonts.ALEXANDRIA_MEDIUM,
//     color: AppTheme.colors.white,
//   },
//   hostView: {
//     width: 60,
//     height: 25,
//     alignItems: "center",
//     justifyContent: "center",
//     borderRadius: 10,
//     marginLeft: 5,
//   },
//   hostText: {
//     fontSize: 14,
//     fontFamily: AppTheme.fonts.ALEXANDRIA_SEMIBOLD,
//     color: AppTheme.colors.white,
//   },
//   bottomText: {
//     alignSelf: "center",
//     fontSize: 22,
//     fontFamily: AppTheme.fonts.BUBBLE_BOBBLE,
//     color: AppTheme.colors.white,
//     textShadowColor: AppTheme.colors.outline,
//     textShadowOffset: { width: 2, height: 2 },
//     textShadowRadius: 2,
//   },
//   googleBtn: {
//     width: 250,
//     height: 58,
//     borderRadius: 30,
//     justifyContent: "center",
//   },

//   googleBtn1: {
//     width: 250,
//     height: 65,
//     borderRadius: 35,
//   },
//   startText: {
//     fontFamily: AppTheme.fonts.BUBBLE_BOBBLE,
//     fontSize: 35,
//     color: AppTheme.colors.white,
//     textAlign: "center",
//     textShadowColor: AppTheme.colors.outline,
//     textShadowOffset: { width: 2, height: 2 },
//     textShadowRadius: 2,
//   },
// });
// @ts-nocheck
import {
  Alert,
  AppState,
  Image,
  ImageBackground,
  Platform,
  Share,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { AppIcons } from "../../../assets/images";
import { AppTheme } from "../../../utils/theme";
import { useNavigation, useRoute } from "@react-navigation/native";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import LinearGradient from "react-native-linear-gradient";
import Spacer from "../../../components/global/Spacer";
import SoundPlayer from "react-native-sound-player";
import { userAction } from "../../../redux/reducers/user";
import { ROUTE_NAME } from "../../../utils/routes";
import socketService from "../../../services/socketService";
import { useAppSelector } from "../../../redux/storeHook";
import { bannerAdKey, DEEP_LINK, truncateText } from "../../../utils/contants";
import FastImage from "react-native-fast-image";
import {
  BannerAd,
  BannerAdSize,
  useForeground,
} from "react-native-google-mobile-ads";

export interface Player {
  id: string;
  userId: string;
  name: string;
  color: string;
  isReady: boolean;
  isHost: boolean;
  disconnectedAt?: number | null;
}

export interface Room {
  id: string;
  hostId: string;
  maxPlayers: number;
  players: Player[];
  gameState: any | null;
  gameStarted: boolean;
  messages: any[];
}

export interface RootObject {
  roomId: string;
  playerName: string;
  color: string;
  isHost: boolean;
  userId: string;
  room: Room;
}
const WaitingRoom = () => {
  const route = useRoute();
  const { userData } = useAppSelector((s) => s.user);
  const navigation = useNavigation<NativeStackNavigationProp<any>>();
  const {
    roomId,
    playerName,
    color,
    isHost: initialIsHost,
    userId,
    room: initialRoom,
  } = route.params as RootObject;
  const [room, setRoom] = useState<Room>(initialRoom);
  const [myReadyState, setMyReadyState] = useState(initialIsHost);

  const bannerRef = useRef<BannerAd>(null);

  useForeground(() => {
    if (Platform.OS === "ios") {
      bannerRef.current?.load();
    }
  });

  const localPlayer = useMemo(
    () => room.players.find((p) => p.userId === userId),
    [room, userId],
  );
  const isLocalHost = !!localPlayer?.isHost;
  const activePlayers = useMemo(
    () => room.players.filter((p) => !p.disconnectedAt),
    [room],
  );
  const allReady = activePlayers.every((p) => p.isReady);
  const canStart = isLocalHost && allReady && activePlayers.length >= 2;

  console.log("@ params : ", route.params);

  const onPress = () => {
    handleStartGame();
  };

  useEffect(() => {
    setupSocketListeners();
    // AppState listener for foreground rejoin
    const subscription = AppState.addEventListener("change", (nextAppState) => {
      if (nextAppState === "active" && socketService.currentRoomId) {
        // Force rejoin on foreground to sync room state
        socketService
          .joinRoom(
            socketService.currentRoomId,
            socketService.currentPlayerName,
            socketService.currentProfilePhoto,
            socketService.currentUserId,
          )
          .then((response: any) => {
            console.log("Foreground rejoin successful");
            // Server will emit playerJoined, which updates room
          })
          .catch((error: any) => {
            if (error !== "Already in room") {
              console.error("Foreground rejoin failed:", error);
            }
          });
      }
    });

    return () => {
      subscription?.remove();
      // socketService.removeListener("playerJoined");
      // socketService.removeListener("playerLeft");
      // socketService.removeListener("roomUpdated");
      // socketService.removeListener("gameStarted");
    };
  }, []);

  useEffect(() => {
    setTimeout(() => {
      handleToggleReady();
    }, 2000);
  }, []);
  const setupSocketListeners = () => {
    // @ts-ignore
    socketService.onPlayerJoined(({ player, room: updatedRoom }) => {
      console.log(
        "Player joined/rejoined, updating room:",
        updatedRoom.players.map((p) => ({
          name: p.name,
          active: !p.disconnectedAt,
        })),
      );
      setRoom(updatedRoom);
    });
    // @ts-ignore
    socketService.onPlayerLeft(({ room: updatedRoom }) => {
      setRoom(updatedRoom);
    });
    // @ts-ignore
    socketService.onRoomUpdated(({ room: updatedRoom }) => {
      setRoom(updatedRoom);
    });
    // @ts-ignore
    socketService.onGameStarted(({ players, numPlayers }) => {
      // Navigate to game screen with online mode
      socketService.removeListener("playerJoined");
      socketService.removeListener("playerLeft");
      socketService.removeListener("roomUpdated");
      socketService.removeListener("gameStarted");
      navigation.replace(ROUTE_NAME.PlayOnline, {
        roomId,
        playerName,
        myColor: color,
        players,
        numPlayers,
      });
    });
  };
  const handleToggleReady = async () => {
    if (isLocalHost) return; // Host is always ready
    try {
      const response: any = await socketService.toggleReady(roomId);
      if (response.success) {
        setMyReadyState(response.isReady);
      }
    } catch (error) {
      Alert.alert("Error", "Failed to update ready state");
    }
  };
  const handleStartGame = async () => {
    try {
      await socketService.startGame(roomId);
    } catch (error) {
      // @ts-ignore
      Alert.alert("Error", error || "Failed to start game");
    }
  };
  const handleLeaveRoom = () => {
    Alert.alert("Leave Room", "Are you sure you want to leave?", [
      { text: "Cancel", style: "cancel" },
      {
        text: "Leave",
        style: "destructive",
        onPress: () => {
          socketService.leaveRoom(roomId);
          socketService.removeListener("playerJoined");
          socketService.removeListener("playerLeft");
          socketService.removeListener("roomUpdated");
          socketService.removeListener("gameStarted");
          navigation.goBack();
        },
      },
    ]);
  };

  const shareRoomCode = async (roomCode: any) => {
    try {
      const appStoreLink =
        Platform.OS === "ios"
          ? "https://apps.apple.com/in/app/ludo-voice/id1511172928"
          : "https://play.google.com/store/apps/details?id=com.netscapelabs.ludovoice";

      //       const message = `🎲 Join my *Ludo Voice* room!

      // 🧩 Room Code: ${roomCode}

      // 📲 Download the app:
      // ${appStoreLink}

      // Open the app, enter the room code, and play with me! 🚀`;

      const deeplink = `${DEEP_LINK}joinroom=${roomCode}`;
      const message = `🎲 Join my *Ludo Voice* room!

🧩 Room Code: ${roomCode}

📲 join the room by clicking on this link:
${deeplink}

📲 Download the app:

${appStoreLink}

Open the app, enter the room code, and play with me! 🚀`;
      await Share.share({
        message: message,
      });
    } catch (error: any) {
      console.log(error.message);
    }
  };
  return (
    <ImageBackground source={AppIcons.screenBackground} style={styles.mainView}>
      <TouchableOpacity
        onPress={() => {
          handleLeaveRoom();
          userAction.setTouchSound(true);
        }}
        style={styles.backIcon}
      >
        <Image
          source={AppIcons.BackIcon}
          style={{
            width: 50,
            height: 40,
          }}
          resizeMode="contain"
        />
      </TouchableOpacity>
      <View style={styles.container}>
        <Text style={styles.title}>Play Online</Text>
        <Text style={styles.t1}>Room Code</Text>
        <View style={styles.roomView}>
          <LinearGradient
            colors={[
              AppTheme.colors.linearGradient_1,
              AppTheme.colors.linearGradient_2,
            ]}
            start={{ x: 0, y: 0 }}
            end={{ x: 1, y: 1 }}
            style={styles.codeView}
          >
            <Text style={styles.title}>{roomId}</Text>
          </LinearGradient>
          <TouchableOpacity
            onPress={() => shareRoomCode(roomId)}
            style={{ marginLeft: 10 }}
          >
            <Image source={AppIcons.Share} style={styles.share} />
          </TouchableOpacity>
        </View>
        <Text style={styles.t2}>
          Share this with your friends and ask them to join
        </Text>
        <Spacer size={30} />
        {/* 2 players ui */}
        {room?.maxPlayers == 2 && (
          <View style={styles.userView}>
            <View style={styles.userCard}>
              {activePlayers[0]?.profilePhoto ? (
                <FastImage
                  source={{ uri: activePlayers[0]?.profilePhoto }}
                  style={styles.icon}
                />
              ) : (
                <Image source={AppIcons.OnlineUser} style={styles.icon} />
              )}
              <View style={styles.rowView}>
                <Text style={styles.name}>
                  {activePlayers.length > 0 &&
                  activePlayers[0]?.name == userData?.name
                    ? "You"
                    : truncateText(activePlayers[0]?.name, 8)}
                </Text>
                {activePlayers.length > 0 && activePlayers[0]?.isHost && (
                  <LinearGradient
                    colors={[
                      AppTheme.colors.linearGradient_1,
                      AppTheme.colors.linearGradient_2,
                    ]}
                    start={{ x: 0, y: 0 }}
                    end={{ x: 1, y: 1 }}
                    style={styles.hostView}
                  >
                    <Text style={styles.hostText}>HOST</Text>
                  </LinearGradient>
                )}
              </View>
            </View>
            <Image
              style={[
                styles.vsImg,
                {
                  left: "45%",
                },
              ]}
              source={AppIcons.vsIcon}
            />
            <View style={styles.userCard}>
              {activePlayers[1]?.profilePhoto ? (
                <FastImage
                  source={{ uri: activePlayers[1]?.profilePhoto }}
                  style={styles.icon}
                />
              ) : (
                <Image source={AppIcons.OnlineUser} style={styles.icon} />
              )}
              <Text style={styles.name}>
                {activePlayers.length >= 2
                  ? activePlayers[1]?.name == userData?.name
                    ? "You"
                    : truncateText(activePlayers[1]?.name, 8)
                  : "Waiting..."}
              </Text>
            </View>
          </View>
        )}
        {/* 3 player */}
        {room?.maxPlayers == 3 && (
          <View style={styles.userView}>
            <View style={styles.userCard}>
              {activePlayers[0]?.profilePhoto ? (
                <FastImage
                  source={{ uri: activePlayers[0]?.profilePhoto }}
                  style={styles.icon}
                />
              ) : (
                <Image source={AppIcons.OnlineUser} style={styles.icon} />
              )}
              <View style={styles.rowView}>
                <Text style={styles.name}>
                  {activePlayers.length > 0 &&
                  activePlayers[0]?.name == userData?.name
                    ? "You"
                    : truncateText(activePlayers[0]?.name, 8)}
                </Text>
                {activePlayers.length > 0 && activePlayers[0]?.isHost && (
                  <LinearGradient
                    colors={[
                      AppTheme.colors.linearGradient_1,
                      AppTheme.colors.linearGradient_2,
                    ]}
                    start={{ x: 0, y: 0 }}
                    end={{ x: 1, y: 1 }}
                    style={styles.hostView}
                  >
                    <Text style={styles.hostText}>HOST</Text>
                  </LinearGradient>
                )}
              </View>
            </View>
            <Image
              style={[
                styles.vsImg,
                {
                  left: "45%",
                },
              ]}
              source={AppIcons.vsIcon}
            />
            <View style={styles.userCard}>
              {activePlayers[1]?.profilePhoto ? (
                <FastImage
                  source={{ uri: activePlayers[1]?.profilePhoto }}
                  style={styles.icon}
                />
              ) : (
                <Image source={AppIcons.OnlineUser} style={styles.icon} />
              )}
              <Text style={styles.name}>
                {activePlayers.length >= 2
                  ? activePlayers[1]?.name == userData?.name
                    ? "You"
                    : truncateText(activePlayers[1]?.name, 8)
                  : "Waiting..."}
              </Text>
            </View>
            <View style={styles.userCard}>
              {activePlayers[2]?.profilePhoto ? (
                <FastImage
                  source={{ uri: activePlayers[2]?.profilePhoto }}
                  style={styles.icon}
                />
              ) : (
                <Image source={AppIcons.OnlineUser} style={styles.icon} />
              )}
              <Text style={styles.name}>
                {activePlayers.length >= 3
                  ? activePlayers[2]?.name == userData?.name
                    ? "You"
                    : truncateText(activePlayers[2]?.name, 8)
                  : "Waiting..."}
              </Text>
            </View>
          </View>
        )}
        {/* 4 players */}
        {room?.maxPlayers == 4 && (
          <View style={styles.userView}>
            <View style={styles.userCard}>
              {activePlayers[0]?.profilePhoto ? (
                <FastImage
                  source={{ uri: activePlayers[0]?.profilePhoto }}
                  style={styles.icon}
                />
              ) : (
                <Image source={AppIcons.OnlineUser} style={styles.icon} />
              )}
              <View style={styles.rowView}>
                <Text style={styles.name}>
                  {activePlayers.length > 0 &&
                  activePlayers[0]?.name == userData?.name
                    ? "You"
                    : truncateText(activePlayers[0]?.name, 8)}
                </Text>
                {activePlayers.length > 0 && activePlayers[0]?.isHost && (
                  <LinearGradient
                    colors={[
                      AppTheme.colors.linearGradient_1,
                      AppTheme.colors.linearGradient_2,
                    ]}
                    start={{ x: 0, y: 0 }}
                    end={{ x: 1, y: 1 }}
                    style={styles.hostView}
                  >
                    <Text style={styles.hostText}>HOST</Text>
                  </LinearGradient>
                )}
              </View>
            </View>
            <Image
              style={[
                styles.vsImg,
                {
                  left: "45%",
                },
              ]}
              source={AppIcons.vsIcon}
            />
            <View style={styles.userCard}>
              {activePlayers[1]?.profilePhoto ? (
                <FastImage
                  source={{ uri: activePlayers[1]?.profilePhoto }}
                  style={styles.icon}
                />
              ) : (
                <Image source={AppIcons.OnlineUser} style={styles.icon} />
              )}
              <Text style={styles.name}>
                {activePlayers.length >= 2
                  ? activePlayers[1]?.name == userData?.name
                    ? "You"
                    : truncateText(activePlayers[1]?.name, 8)
                  : "Waiting..."}
              </Text>
            </View>
            <View style={styles.userCard}>
              {activePlayers[2]?.profilePhoto ? (
                <FastImage
                  source={{ uri: activePlayers[2]?.profilePhoto }}
                  style={styles.icon}
                />
              ) : (
                <Image source={AppIcons.OnlineUser} style={styles.icon} />
              )}
              <Text style={styles.name}>
                {activePlayers.length >= 3
                  ? activePlayers[2]?.name == userData?.name
                    ? "You"
                    : truncateText(activePlayers[2]?.name, 8)
                  : "Waiting..."}
              </Text>
            </View>
            <View style={styles.userCard}>
              {activePlayers[3]?.profilePhoto ? (
                <FastImage
                  source={{ uri: activePlayers[3]?.profilePhoto }}
                  style={styles.icon}
                />
              ) : (
                <Image source={AppIcons.OnlineUser} style={styles.icon} />
              )}
              <Text style={styles.name}>
                {activePlayers.length >= 4
                  ? activePlayers[3]?.name == userData?.name
                    ? "You"
                    : truncateText(activePlayers[3]?.name, 8)
                  : "Waiting..."}
              </Text>
            </View>
          </View>
        )}
        <Spacer size={20} />
        {canStart ? (
          <TouchableOpacity
            activeOpacity={1}
            style={{ alignSelf: "center", marginTop: 20 }}
            onPress={() => {
              onPress();
              // SoundPlayer.stop();
              userAction.setMusicPreference(false);
              userAction.setTouchSound(true);
              userAction.setPlayGame(true);
            }}
          >
            <LinearGradient
              colors={[
                AppTheme.colors.linearGradient_5,
                AppTheme.colors.linearGradient_6,
              ]}
              start={{ x: 0, y: 0 }}
              end={{ x: 1, y: 1 }}
              style={styles.googleBtn1}
            >
              <LinearGradient
                colors={[
                  AppTheme.colors.linearGradient_1,
                  AppTheme.colors.linearGradient_2,
                ]}
                start={{ x: 0, y: 0 }}
                end={{ x: 1, y: 1 }}
                style={styles.googleBtn}
              >
                <Text style={styles.startText}>START GAME</Text>
              </LinearGradient>
            </LinearGradient>
          </TouchableOpacity>
        ) : (
          <Text style={styles.bottomText}>
            {isLocalHost
              ? "Waiting for players to join ...."
              : "Waiting for host to start the game ...."}
          </Text>
        )}
      </View>
      <View style={styles.botttomView}>
        <BannerAd
          ref={bannerRef}
          unitId={bannerAdKey}
          size={BannerAdSize.ANCHORED_ADAPTIVE_BANNER}
        />
      </View>
    </ImageBackground>
  );
};

export default WaitingRoom;

const styles = StyleSheet.create({
  mainView: {
    flex: 1,
  },
  backIcon: {
    position: "absolute",
    top: 70,
    right: 0,
    zIndex: 999,
    elevation: 999,
  },
  container: {
    flex: 1,
    justifyContent: "center",
  },
  title: {
    alignSelf: "center",
    fontSize: 36,
    fontFamily: AppTheme.fonts.BUBBLE_BOBBLE,
    color: AppTheme.colors.white,
    textShadowColor: AppTheme.colors.outline,
    textShadowOffset: { width: 2, height: 2 },
    textShadowRadius: 2,
  },
  share: {
    height: 40,
    width: 40,
  },
  t1: {
    alignSelf: "center",
    marginVertical: 10,
    fontSize: 18,
    color: `${AppTheme.colors.white}80`,
    fontFamily: AppTheme.fonts.ALEXANDRIA_BOLD,
  },
  roomView: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  codeView: {
    alignSelf: "center",
    width: 180,
    height: 60,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 14,
  },
  t2: {
    width: 280,
    alignSelf: "center",
    marginVertical: 10,
    fontSize: 16,
    color: `${AppTheme.colors.white}80`,
    fontFamily: AppTheme.fonts.ALEXANDRIA_MEDIUM,
    textAlign: "center",
  },
  userView: {
    width: "100%",
    paddingHorizontal: 24,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    position: "relative",
  },
  userCard: {
    alignItems: "center",
    marginTop: 10,
  },
  icon: {
    width: 130,
    height: 130,
    marginBottom: 7,
    borderRadius: 20,
  },
  vsImg: {
    position: "absolute",
    zIndex: 999,
    height: 80,
    width: 80,
  },
  rowView: {
    flexDirection: "row",
    alignItems: "center",
  },
  name: {
    fontSize: 16,
    fontFamily: AppTheme.fonts.ALEXANDRIA_MEDIUM,
    color: AppTheme.colors.white,
  },
  hostView: {
    width: 60,
    height: 25,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 10,
    marginLeft: 5,
  },
  hostText: {
    fontSize: 14,
    fontFamily: AppTheme.fonts.ALEXANDRIA_SEMIBOLD,
    color: AppTheme.colors.white,
  },
  bottomText: {
    alignSelf: "center",
    fontSize: 22,
    fontFamily: AppTheme.fonts.BUBBLE_BOBBLE,
    color: AppTheme.colors.white,
    textShadowColor: AppTheme.colors.outline,
    textShadowOffset: { width: 2, height: 2 },
    textShadowRadius: 2,
  },
  googleBtn: {
    width: 250,
    height: 58,
    borderRadius: 30,
    justifyContent: "center",
  },

  googleBtn1: {
    width: 250,
    height: 65,
    borderRadius: 35,
  },
  startText: {
    fontFamily: AppTheme.fonts.BUBBLE_BOBBLE,
    fontSize: 35,
    color: AppTheme.colors.white,
    textAlign: "center",
    textShadowColor: AppTheme.colors.outline,
    textShadowOffset: { width: 2, height: 2 },
    textShadowRadius: 2,
  },
  botttomView: {
    position: "absolute",
    bottom: 10,
  },
});
